module.exports = __webpack_public_path__ + "img/25.23557ed0.jpg";